import ABCyaPhaser from "@abcya/abcya_phaser";
import FontKeys from "../FontKeys";
import Monster from "../game/Monster";
import { dotPop } from "../Utilities";

export default class GameHud extends Phaser.GameObjects.Container
{
    constructor(scene)
    {
        super(scene);

        this.sideContainer = null;

        this.title = null;

        this.timeContainer = null;
        this.lblTime = null;
        this.txtTime = null;

        this.strikeContainer = null;
        this.lblStrikes = null;
        this.strikes = null;
        this.xContainer = null;

        this.sizeContainer = null;
        this.sizeBg = null;
        this.lblSize = null;
        this.monster = null;

        this.sideWidth = 0;

        this.lblResult = null;

        this.timeTween = null;
        this.curTime = 0;

        this.sideContainer = this.scene.add.container();

        this.title = ABCyaPhaser.Images.addImage(0, 0, "HudTitle", this.scene).setOrigin(0.5);

        this.timeContainer = this.scene.add.container();
        this.lblTime = ABCyaPhaser.Images.addImage(0, 0, "Label_Time", this.scene).setOrigin(0.5, 0);
        this.txtTime = ABCyaPhaser.Text.addText(0, 0, 60, 0xffffff, FontKeys._asapbold, "0", this.scene).setOrigin(0.5, 0);
        this.txtTime.text = this.curTime.toString();
        this.txtTime.y = this.lblTime.height;
        this.timeContainer.add([this.lblTime, this.txtTime]);

        this.strikeContainer = this.scene.add.container();
        this.lblStrikes = ABCyaPhaser.Images.addImage(0, 0, "Label_Strikes", this.scene);
        this.strikes = [];
        this.xContainer = this.scene.add.container();
        for (let i = 0; i < 3; i++)
        {
            let s = ABCyaPhaser.Images.addImage(i * 40, 0, "StrikeX", this.scene).setOrigin(0.5).setScale(0).setAlpha(0);
            s.y = this.lblStrikes.height + 10 + (s.height / 2);
            this.strikes.push(s);
            this.xContainer.add(s);
        }
        this.xContainer.x = (this.lblStrikes.width - this.xContainer.getBounds().width) / 2;
        this.strikeContainer.add([this.lblStrikes, this.xContainer]);

        this.sizeContainer = this.scene.add.container();
        this.sizeBg = ABCyaPhaser.Images.addImage(0, 0, "GoalBg", this.scene);
        this.lblSize = ABCyaPhaser.Images.addImage(0, 0, "Label_Goal", this.scene);
        this.lblSize.y = this.sizeBg.height + 10;
        this.lblSize.x = this.sizeBg.width / 2 - this.lblSize.width / 2;
        this.monster = new Monster(this.scene);
        this.monster.initSmall();
        this.monster.x = 30 + (this.monster.workingWidth / 2);
        this.monster.y = this.monster.workingHeight;
        this.sizeContainer.add([this.monster, this.sizeBg, this.lblSize]);

        // in Createjs you could change the pivot of a container, in Phaser you can't, this fixes that
        let bounds = this.strikeContainer.getBounds();
        this.strikeContainer.iterate(child =>
        {
            child.x -= bounds.width / 2;
            child.y -= bounds.height / 2;
        });
        bounds = this.sizeContainer.getBounds();
        this.sizeContainer.iterate(child =>
        {
            child.x -= bounds.width / 2;
            child.y -= bounds.height / 2;
        });

        this.title.y = 40;
        this.timeContainer.y = 125;
        this.strikeContainer.y = 320;
        this.sizeContainer.y = 560;

        this.sideContainer.add([this.title, this.timeContainer, this.strikeContainer, this.sizeContainer]);

        this.add(this.sideContainer);

        this.sideWidth = this.sizeBg.width;
        this.sideContainer.y = 40;
        this.sideContainer.x = this.scene.scale.width - this.sideWidth / 2 - 10;
    }

    startTime()
    {
        if (!this.timeTween != null)
        {
            this.curTime = 0;
            this.timeTween = ABCyaPhaser.Timer.addRepeatingEvent(this.scene, 1000, () => this.updateTime(), -1);
        }
    }

    updateTime()
    {
        this.curTime++;
        this.txtTime.text = this.curTime.toString();
    }

    stopTime()
    {
        if (this.timeTween != null)
        {
            this.timeTween.remove();
            this.timeTween = null;
        }
    }

    getMonsterLoc()
    {
        let pt = ABCyaPhaser.GameObjects.getScreenPosition(this.monster);
        pt.y -= (this.monster.workingHeight / 2 * this.monster.container.scaleY) - (20 * this.monster.container.scaleY);
        return pt;
    }

    feedHim()
    {
        this.monster.eat();
    }

    showGameWin(waittime, x, y)
    {
        if (!this.lblResult)
        {
            this.lblResult = ABCyaPhaser.Images.addImage(x, y, "Label_GoodJob", this).setOrigin(0.5);
        }
        this.lblResult.setScale(0).setPosition(x, y);

        this.scene.tweens.timeline({
            tweens:
                [
                    ABCyaPhaser.Tweens.createTween(this.lblResult, 1200, { delay: waittime, scale: 1.2, angle: 1800 }, Phaser.Math.Easing.Linear),
                    ABCyaPhaser.Tweens.createTween(this.lblResult, 360, { scale: 1 }, Phaser.Math.Easing.Linear),
                ]
        });
        return 2800 + waittime;
    }

    showStrike(strikeCount)
    {
        dotPop(this.strikes[strikeCount - 1], 440);
        return 1500;
    }

    showStrikeOut(waittime, x, y)
    {
        if (!this.lblResult)
        {
            this.lblResult = ABCyaPhaser.Images.addImage(x, y, "Label_ThreeStrikes", this).setOrigin(0.5);
        }
        this.lblResult.setScale(0).setPosition(x, y);

        this.scene.tweens.timeline({
            tweens:
                [
                    ABCyaPhaser.Tweens.createTween(this.lblResult, 1200, { delay: waittime, scale: 1.2, angle: 1800 }, Phaser.Math.Easing.Linear),
                    ABCyaPhaser.Tweens.createTween(this.lblResult, 360, { scale: 1 }, Phaser.Math.Easing.Linear),
                ]
        });
        
        return 2800 + waittime;
    }

    preUpdate(time, dt)
    {
        this.monster.tick(dt / 1000);
    }
}